import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import moment from 'moment-timezone';
import { If, Then } from 'react-if';

import BarCodeReader from '../components/BarCodeReader';

import StyledPage from '../components/StyledPage';
import Button from '../components/Button';
import ModalWindow from '../components/ModalWindow';


import Loading from '../components/Loading';
import ConfirmBox from '../components/ConfirmBox';

import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import FormErrors, { trowError } from '../components/FormErrors';

import { MUTATION_GASTRONOMIC_GUIDE_LIST_TICKET_BY_CODE_SCAN } from '../models/GuiaGastronomica';

const AuthLayoutWrapperStyled=styled(AuthLayoutWrapper)`
  form{
    max-width: 600px !important;
  }
`;

const StyleModal = styled.div`
  h1{
    text-align: center;
  }
  .principal{
    font-size: 50px;
  }
  .logo{
    max-width: 200px;
  }
  .center{text-align:center}
  h2{
    text-align: center;
  }

  table{
    td,th{
      padding: 10px;
    }
  }
`;

const GroupButtons = styled.div`
  display:grid;
  grid-template-columns: auto 60px;
  gap:30px;
  @media (max-width: 400px){
    grid-template-columns: 100%;
    grid-template-areas:"label" "input";
  }
`;

const ButtonFulll=styled.div`
    display: flex;
    width: 100%;
    padding-top: 50px;
`;

const TableConfirmStyled = styled.table`
  max-width:500px;
  margin:auto !important;
`;

export default () => {
    const [ticket, setTicket] = useState<any>(null);
    const [showScanQR, setShowScanQR] = useState<boolean>(false);
    const [submitError,setSubmitError] = useState<null|string>(null);
    const [passwordSave,setPasswordSave] = useState<null|string>(null);

    const [ticketCodescan, { error, loading }] = useMutation(MUTATION_GASTRONOMIC_GUIDE_LIST_TICKET_BY_CODE_SCAN);

    const { register, handleSubmit, setValue } = useForm({
        defaultValues:(process.env.NODE_ENV==='development')?{
            password:'',
            code:'a3452318-0d3d-4781-ac92-f4ea9fb4cfd2',
        }:{}
    });

    const onSubmit = async ({ code, password }:{code:string, password?:string}) => {
        setTicket(null);        
        try {
            const passwordSend= password || passwordSave;
            const response = await ticketCodescan({
                variables: {
                    code,
                    password:passwordSend
                },
            });

            if(response.errors)
                throw new trowError(response.errors);

            if(!passwordSave) setPasswordSave(password);

            setTicket(response.data?.getGastronomicGuideListTicketByCodeScan);
          
            console.log({response});

        } catch (e) {
            console.error(e);
            setSubmitError(e);
        }
    };

    const onSacned = (text:string) => {
        setValue('code', text);
        setShowScanQR(false);
        onSubmit({ code: text });
    };
    return (
        <StyledPage>
            <AuthLayoutWrapperStyled>
                {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}
                <form  onSubmit={handleSubmit(onSubmit)}>
                ` <div className="title">Lectura de QR</div>
                    <br />
                    <If condition={passwordSave==null}>
                        <Then>
                            <input type="password" name="password" placeholder="Password" ref={register} required />
                            <br />
                        </Then>
                    </If>
                    <input type="text" name="code" placeholder="Code" ref={register} required />

                    <GroupButtons>
                        <Button disabled={loading} className="important red-btn">Validar</Button>
                        <Button className="important red-btn" onClick={() => setShowScanQR(true)}>
                            <i className="fas fa-camera" />
                        </Button>
                    </GroupButtons>

                </form>
            </AuthLayoutWrapperStyled>

            <If condition={ticket !== null}>
                <Then>
                    <ModalWindow onClickClose={() => setTicket(null)}>
                        <StyleModal>
                            <br />
                            <br />
                            <h1 className='title principal'>{ticket?.gastronomicGuide?.nombre}</h1>
                            <div className='center'><img  className="logo" src={ticket?.gastronomicGuide?.logo_path_url} /></div>
                            <ConfirmBox className={(ticket?.first_scan !== ticket?.last_scan) ? 'error' : ''}>
                                <h1>
                                    {(ticket?.first_scan !== ticket?.last_scan) ? 'QR leído' : ' QR válido'}
                                </h1>
                                <TableConfirmStyled>
                                    <tr>
                                        <th className="td-let">Primera lectura:</th>
                                        <td>
                                            {moment(ticket?.first_scan).format('DD [de] MMMM [del ] YYYY')}
                                            <br />
                                            {moment(ticket?.first_scan  ).format('HH:mm [hrs]')}
                                        </td>
                                        <th className="td-let">Última lectura:</th>
                                        <td>
                                            {moment(ticket?.last_scan).format('DD [de] MMMM [del ] YYYY')}
                                            <br />
                                            {moment(ticket?.last_scan).format('HH:mm [hrs]')}
                                        </td>
                                    </tr>
                                </TableConfirmStyled>
                            </ConfirmBox>

                            <ButtonFulll>
                                <Button className="important red-btn" onClick={() => {
                                    setTicket(null);
                                    setShowScanQR(true);
                                }}
                                >
                                    <i className="fas fa-camera" />
                                </Button>
                            </ButtonFulll>


                        </StyleModal>
                    </ModalWindow>
                </Then>
            </If>

            <If condition={showScanQR}>
                <Then>
                    <ModalWindow onClickClose={() => setShowScanQR(false)}>
                        <div>
                            <BarCodeReader style={{ width: '100%', height: '83vh' }} onScan={onSacned} />
                        </div>
                    </ModalWindow>
                </Then>
            </If>            
        </StyledPage>
    );
};
